(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaDialogCompleteController', NormaDialogCompleteController);

    NormaDialogCompleteController.$inject = ['$q', '$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entityNorma', 'organosResponse', 'documentosResponse', 'actualizaNormaId', 'Norma', 'Documento', 'OrganoRelevante', 'Organo', 'PalabraClave', 'Materia', 'PalabraClaveSearch', 'OrganoSearch', 'TipoOrdenamientoSearch', 'NormaSearch'];

    function NormaDialogCompleteController($q, $timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entityNorma, organosResponse, documentosResponse, actualizaNormaId, Norma, Documento, OrganoRelevante, Organo, PalabraClave, Materia, PalabraClaveSearch, OrganoSearch, TipoOrdenamientoSearch, NormaSearch) {
        var vm = this;

        vm.norma = entityNorma;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        vm.materias = Materia.query();

        vm.uploadStart = uploadStart;
        vm.successUpload = successUpload;
        vm.removeFiles = removeFiles;
        vm.loading = false;
        vm.error = false;
        vm.completeUpload = completeUpload;
        vm.errorUpload = errorUpload;
        vm.flow = null;
        vm.flowActualizado = null;
        vm.cargando = {PUBLICADO: false, ACTUALIZADO: false};
        vm.completeUploadActualizado = completeUploadActualizado;
        vm.esPublicado = esPublicado;
        vm.esActualizado = esActualizado;

        vm.numPalabras = 200;
        vm.responsePalabras = [];
        vm.responseOrganos = [];
        vm.responseOrdenamientos = [];
        vm.responseNormas = [];
        vm.addWord = addWord;
        vm.removeWord = removeWord;
        vm.autocompletePalabra = autocompletePalabra;
        vm.autocompleteOrgano = autocompleteOrgano;
        vm.autocompleteOrdenamiento = autocompleteOrdenamiento;
        vm.autocompleteNormas = autocompleteNormas;
        vm.promisesPalabra = [];
        vm.promisesOrgano = [];
        vm.organos = [];
        vm.addOrgano = addOrgano;
        vm.removeOrgano = removeOrgano;
        vm.tipoOrdenamiento;
        vm.addOrdenamiento = addOrdenamiento;
        vm.addDepurado = addDepurado;
        vm.removeDepurado = removeDepurado;
        vm.addAbrogado = addAbrogado;
        vm.removeAbrogado = removeAbrogado;
        vm.documentosResponse = documentosResponse;
        vm.deleteFile = deleteFile;
        vm.filesToRemove = [];

        vm.fechaEmisionPendTextOriginal = null;
        ini();

        function ini() {
            if (vm.norma.tipoOrdenamientoId !== undefined && vm.norma.tipoOrdenamientoId !== null) {
                vm.modelOrdenamiento = {};
                vm.modelOrdenamiento.id = vm.norma.tipoOrdenamientoId;
                vm.modelOrdenamiento.nombre = vm.norma.tipoOrdenamientoNombre;
            }
            if (organosResponse !== null) {
                for (var i = 0; i < organosResponse.length; i++) {
                    var organo = {};
                    organo.id = organosResponse[i].organoId;
                    organo.nombre = organosResponse[i].organoNombre;
                    vm.organos.push(organo);
                }
            }
        }
        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
        /*No se habilita save en el proceso de carga de los archivos*/
        function save() {
            vm.isSaving = true;
            createPalabrasClave();
            createOrganos();
            emtpyDates();
            $q.all(vm.promisesPalabra.concat(vm.promisesOrgano)).then(function() {
                console.log("Solved all the promises");
                if (actualizaNormaId) {
                    // "Actualizar Norma": se guarda primero como histórico de la norma
                    // actual (mismo mecanismo que "Agregar Histórico"), y se cambia a vigente).
                    vm.norma.esVigente = false;
                    vm.norma.normaVigenteActualId = actualizaNormaId;
                    Norma.save({skipIndexVigente: true}, vm.norma, onSaveComoReemplazo, onSaveNormaError);

                } else if (vm.norma.id !== null) {
                    Norma.update(vm.norma, onSaveNormaSuccess, onSaveNormaError);

                } else {
                    Norma.save(vm.norma, onSaveNormaSuccess, onSaveNormaError);

                }

            }).catch(function() {
                console.error("error at exec all the promises");
                return $q.reject("error");
            });

        }

        function onSaveComoReemplazo(result) {
            Norma.hacerVigente({id: result.id}, {}, onSaveNormaSuccess, onSaveNormaError);
        }

        // Solo puede haber un documento actualizado: si se subió uno nuevo, el que ya estaba guardado se elimina
        function reemplazarActualizado() {
            if (vm.flowActualizado == null || vm.flowActualizado.files.length === 0 || !vm.documentosResponse) {
                return;
            }
            vm.documentosResponse.filter(esActualizado).forEach(function(documento) {
                if (vm.filesToRemove.indexOf(documento) === -1) {
                    vm.filesToRemove.push(documento);
                }
            });
        }
        function emtpyDates() {
            if (vm.norma.fechaEmisionPend === false) {
                vm.norma.fechaEmisionPendText = '';
            }
            if (vm.norma.fechaPublicacionPend === false) {
                vm.norma.fechaPublicacionPendText = '';
            }
            if (vm.norma.fechaDOFPend === false) {
                vm.norma.fechaDOFPendText = '';
            }
            if (vm.norma.fechaSJFYGPend === false) {
                vm.norma.fechaSJFYGPendText = '';
            }
            if (vm.norma.fechaSJFGacetaPend === false) {
                vm.norma.fechaSJFGacetaPendText = '';
            }
        }

        function onSaveNormaSuccess(result) {
            vm.resultNormaEntity = result;
            createDocumento();
            createOrganosRelevantes();
            reemplazarActualizado();
            removeLoadedFiles();
            $scope.$emit('sgnmrApp:normaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;

        }

        function onSaveNormaError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaEmision = false;
        vm.datePickerOpenStatus.fechaPublicacion = false;

        vm.setAbstractoConcreto = function($file, norma) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        norma.abstractoConcreto = base64Data;
                        norma.abstractoConcretoContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
        ///-------------------------------
        function uploadStart($flow) {
            vm.loading = true;
            $flow.opts.headers = {
                'X-XSRF-TOKEN': getCSRF()
            };
            vm.error = false;
        }

        function getCSRF() {
            var name = "XSRF-TOKEN=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1);
                if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
            }
            return "";
        }

        function successUpload($flow) {
            console.log("size total: " + $flow.sizeUploaded());
        }

        function removeFiles($flow, index) {
            $flow.removeFile($flow.files[index]);
        }

        function deleteFile(file) {
            vm.filesToRemove.push(file);
            for (var i = 0; i < vm.documentosResponse.length; i++) {
                if (vm.documentosResponse[i].id == file.id) {
                    vm.documentosResponse.splice(i, 1);
                    break;
                }
            }
        }

        function removeLoadedFiles() {

            for (var i = 0; i < vm.filesToRemove.length; i++) {
                console.log(vm.filesToRemove[i].nombre);
                Documento.delete({
                    id: vm.filesToRemove[i].id
                }, onDeleteDocumentSuccess, onDeleteDocumentError);
            };
        }

        function onDeleteDocumentSuccess() {
            console.log("onDeleteDocumentSuccess");
        }

        function onDeleteDocumentError() {
            console.log("onDeleteDocumentError");
        }

        function errorUpload($file, $message, $flow, tipoDocumento) {
            tipoDocumento = tipoDocumento || 'PUBLICADO';
            vm.isSaving = false;
            $flow.removeFile($file);
            vm.error = true;
            vm.tipoConError = tipoDocumento;
            var data = angular.fromJson($message);
            vm.error_message = data.error + ". Archivo:" + $file.name + ". Intente cargar nuevamente.";
            vm.cargando[tipoDocumento] = false;
            actualizarLoading();
        }

        function completeUpload($flow) {
            vm.flow = $flow;
            vm.cargando.PUBLICADO = false;
            actualizarLoading();
        }

        function completeUploadActualizado($flow) {
            vm.flowActualizado = $flow;
            vm.cargando.ACTUALIZADO = false;
            actualizarLoading();
        }

        // El botón Guardar sigue bloqueado mientras cualquiera de las dos cargas esté en curso
        function actualizarLoading() {
            vm.loading = vm.cargando.PUBLICADO || vm.cargando.ACTUALIZADO;
        }

        function esPublicado(documento) {
            return documento.tipo !== 'ACTUALIZADO';
        }

        function esActualizado(documento) {
            return documento.tipo === 'ACTUALIZADO';
        }

        function createDocumento() {
            registrarDocumentos(vm.flow, 'PUBLICADO');
            registrarDocumentos(vm.flowActualizado, 'ACTUALIZADO');
        }

        function registrarDocumentos(flow, tipo) {
            if (flow == null) {
                return;
            }
            for (var i = 0; i < flow.files.length; i++) {
                var doc = {};
                var documento = flow.files[i];
                doc.tipo = tipo;
                doc.mimeType = documento.getType();
                doc.nombre = documento.name;
                doc.length = documento.size;
                doc.path = "/files/" + documento.relativePath;
                doc.normaId = vm.resultNormaEntity.id;
                doc.normaDenominacion = vm.resultNormaEntity.denominacion;
                if (documento.getType() == "pdf") {
                    doc.mimeType = "application/pdf";
                }
                Documento.save(doc, onSaveDocumentSuccess, onSaveDocumentError);
            }
        }

        function onSaveDocumentSuccess(result) {
            console.log("onSaveDocumentSuccess");
            console.log(result);

        }

        function onSaveDocumentError() {
            console.log("onSaveDocumentError");
        }

        function autocompletePalabra(input_query) {

            return PalabraClaveSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: vm.numPalabras,
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responsePalabras = data;
                return data;
            }).catch(function() {
                console.error("error autocompletePalabra");
                return $q.reject("error");
            });
        }

        function addWord() {
            var word = {};
            var flag = false;
            if (vm.modelPalabra != null) {
                // Cuando se selecciona un elemento de la lista desplegable
                if (vm.modelPalabra.palabra != undefined) {
                    word.palabra = vm.modelPalabra.palabra;
                    word.id = vm.modelPalabra.id;
                } else { // Si no se encuentra coindicendia
                    word.palabra = vm.modelPalabra.trim();
                    word.palabra = word.palabra.toUpperCase();
                    word.id = null;
                    // En el caso de que se le "agregar" en lugar de la lista desplegada
                    for (var i = 0; i < vm.responsePalabras.length; i++) {
                            if(vm.responsePalabras[i].palabra.toUpperCase() == word.palabra){
                                 word.id = vm.responsePalabras[i].id;
                                 break;
                            }
                    };
                }
                for (var i = 0; i < vm.norma.palabrasClaves.length; i++) {
                    if (vm.norma.palabrasClaves[i].palabra == word.palabra) {
                        flag = true;
                        break;
                    }
                }
                if (!flag && word !== null) {
                    if (word.palabra.trim().length > 0) {
                        vm.norma.palabrasClaves.push(word);
                    }
                }
                vm.modelPalabra = null;
            }

        }

        function createPalabrasClave() {
            console.log(vm.norma.palabrasClaves);
            var flag = false;
            if (vm.norma.palabrasClaves !== null && vm.norma.palabrasClaves.length > 0) {

                for (var i = 0; i < vm.norma.palabrasClaves.length; i++) {
                    var palabraEntity = vm.norma.palabrasClaves[i];
                    if (palabraEntity.id === null) {
                        vm.promisesPalabra.push(promisePalabra(palabraEntity));
                    }
                }


            }
        }

        function promisePalabra(palabraEntity) {
            return PalabraClave.save(palabraEntity).$promise.then(function(result) {
                for (var i = 0; i < vm.norma.palabrasClaves.length; i++) {
                    if (vm.norma.palabrasClaves[i].palabra === result.palabra) {
                        vm.norma.palabrasClaves[i].id = result.id;
                        break;
                    }
                }
            }).catch(function() {
                console.error("error promisePalabra");
                return $q.reject("error");
            });
        }

        function autocompleteOrgano(input_query) {
            return OrganoSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: vm.numPalabras,
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responseOrganos = data;
                return data;
            }).catch(function() {
                console.error("error autocompleteOrgano");
                return $q.reject("error");
            });

        }

        function removeWord(palabra) {
            for (var i = 0; i < vm.norma.palabrasClaves.length; i++) {
                if (vm.norma.palabrasClaves[i].palabra === palabra.palabra) {
                    vm.norma.palabrasClaves.splice(i, 1);
                    break;
                }
            }
        }

        function addOrgano() {
            var organo = {};
            var flag = false;
            if (vm.modelOrgano != null) {
                if (vm.modelOrgano.nombre != undefined) {
                    organo.nombre = vm.modelOrgano.nombre;
                    organo.id = vm.modelOrgano.id;
                } else {
                    organo.nombre = vm.modelOrgano.trim();
                    organo.nombre = organo.nombre.toUpperCase();
                    organo.id = null;
                    // En el caso de que se le "agregar" en lugar de la lista desplegada
                    for (var i = 0; i < vm.responseOrganos.length; i++) {
                        if (vm.responseOrganos[i].nombre.toUpperCase() == organo.nombre) {
                            organo.id = vm.responseOrganos[i].id;
                            break;
                        }
                    };
                }
                for (var i = 0; i < vm.organos.length; i++) {
                    if (vm.organos[i].nombre == organo.nombre) {
                        flag = true;
                        break;
                    }
                }
                if (flag == false && organo != null) {
                    if (organo.nombre.trim().length > 0) {
                        vm.organos.push(organo);
                    }
                }
                vm.modelOrgano = null;
            }

        }

        function createOrganos() {
            console.log(vm.organos);
            var flag = false;
            if (vm.organos != null && vm.organos.length > 0) {

                for (var i = 0; i < vm.organos.length; i++) {
                    var organoEntity = vm.organos[i];
                    if (organoEntity.id == null) {
                        vm.promisesOrgano.push(promiseOrgano(organoEntity));
                    }
                }


            }
        }

        function promiseOrgano(organoEntity) {
            return Organo.save(organoEntity).$promise.then(function(result) {
                for (var i = 0; i < vm.organos.length; i++) {
                    if (vm.organos[i].nombre === result.nombre) {
                        vm.organos[i].id = result.id;
                        break;
                    }
                }
            }).catch(function() {
                console.error("error promiseOrgano");
                return $q.reject("error");
            });
        }

        function createOrganosRelevantes() {

            var inResponse = false;
            var inOrganos = false;

            if (vm.organos != null) {
                for (var i = 0; i < vm.organos.length; i++) {

                    if (vm.organos[i].id != null) {
                        if (organosResponse != null) {
                            for (var j = 0; j < organosResponse.length; j++) {

                                if (vm.organos[i].id == organosResponse[j].organoId) {

                                    inResponse = true;
                                    break;
                                }
                            }
                        }
                        if (inResponse == false) {
                            inResponse = false;

                            var organoRelevante = {};
                            organoRelevante.id = null;
                            organoRelevante.tipo = "EMISOR";
                            organoRelevante.normaId = vm.resultNormaEntity.id;
                            organoRelevante.normaDenominacion = vm.resultNormaEntity.denominacion;
                            organoRelevante.organoId = vm.organos[i].id;
                            organoRelevante.organoNombre = vm.organos[i].nombre;
                            console.log("save organoRelevante" + organoRelevante.organoId);
                            OrganoRelevante.save(organoRelevante, onSaveOrganoRelevanteSuccess, onSaveOrganoRelevanteError);
                        } else {
                            inResponse = false;
                        }
                    }
                }
            }
            if (organosResponse != null) {
                for (var i = 0; i < organosResponse.length; i++) {
                    if (vm.organos != null) {
                        for (var j = 0; j < vm.organos.length; j++) {
                            if (vm.organos[j].id == organosResponse[i].organoId) {
                                inOrganos = true;
                                break;
                            }
                        };
                    }
                    if (inOrganos == false) { // delete
                        inResponse = false;
                        console.log("delete organoRelevante" + organosResponse[i].organoId);
                        OrganoRelevante.delete({
                            id: organosResponse[i].id
                        }, onDeleteOrganoRelevanteSuccess, onDeleteOrganoRelevanteError);
                    } else {
                        inOrganos = false;
                    }
                };

            }

        }

        function onSaveOrganoRelevanteSuccess(result) {
            console.log("onSaveOrganoRelevanteSuccess");
            console.log(result);
        }

        function onSaveOrganoRelevanteError() {
            console.error("error onSaveOrganoRelevanteError");
        }

        function onDeleteOrganoRelevanteSuccess() {
            console.log("onDeleteOrganoRelevanteSuccess");
        }

        function onDeleteOrganoRelevanteError() {
            console.error("onDeleteOrganoRelevanteError");
        }

        function autocompleteOrdenamiento(input_query) {

            return TipoOrdenamientoSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: vm.numPalabras,
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responseOrdenamientos = data;
                return data;
            }).catch(function() {
                console.error("error autocompleteOrdenamiento");
                return $q.reject("error");
            });
        }

        function removeOrgano(organo) {

            for (var i = 0; i < vm.organos.length; i++) {
                if (vm.organos[i].nombre == organo.nombre) {
                    vm.organos.splice(i, 1);
                    break;
                }
            }
        }

        function addOrdenamiento() {
            if (vm.modelOrdenamiento != null) {
                if (vm.modelOrdenamiento.nombre != undefined) {
                    vm.norma.tipoOrdenamientoId = vm.modelOrdenamiento.id;
                    vm.norma.tipoOrdenamientoNombre = vm.modelOrdenamiento.nombre;

                } else {
                    for (var i = 0; i < vm.responseOrdenamientos.length; i++) {
                        if (vm.responseOrdenamientos[i].nombre.toUpperCase() == vm.modelOrdenamiento.toUpperCase()) {
                            console.log("añadir id Ordenamiento");
                            vm.norma.tipoOrdenamientoId = vm.responseOrdenamientos[i].id;
                            vm.norma.tipoOrdenamientoNombre = vm.responseOrdenamientos[i].nombre;
                            break;
                        }
                    };
                }
            }
        }

        function formatInputQuery(input_query) {
            var query = "";
            var aux_input = formatInput(input_query);
            if (aux_input != null) {
                query = "\"^" + aux_input + "\"$";
                if (query.indexOf(" ") < 0) {
                    query = query + " and " + aux_input + "*";
                }
            }
            return query;
        }

        function formatInput(input_query) {
            var output = "";
            if (input_query != null) {
                input_query.toUpperCase();
                output = input_query.replace("/", "?");
            }
            return output.trim();
        }

        function autocompleteNormas(input_query) {

            return NormaSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: "100",
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responseNormas = data;
                return data;
            }).catch(function() {
                console.error("error autocompleteOrdenamiento");
                return $q.reject("error");
            });
        }

        function addDepurado() {
            console.log("addDepurado");
            var depurado = {};
            var flag = false;
            if (vm.modelDepuradoNorma != null) {
                if (vm.modelDepuradoNorma.denominacion != undefined) {
                    //depurado.denominacion =  vm.modelDepuradoNorma.denominacion;
                    //depurado.id   =  vm.modelDepuradoNorma.id;
                    depurado = vm.modelDepuradoNorma;
                } else {
                    depurado.denominacion = vm.modelDepuradoNorma.trim();
                    depurado.denominacion = depurado.denominacion.toUpperCase();
                    depurado.id = null;
                    for (var i = 0; i < vm.responseNormas.length; i++) {
                        if (vm.responseNormas[i].denominacion.toUpperCase() == depurado.denominacion) {
                            depurado = vm.responseNormas[i];
                            break;
                        }
                    };
                }
                for (var i = 0; i < vm.norma.depuradoPors.length; i++) {
                    if (vm.norma.depuradoPors[i].denominacion == depurado.denominacion) {
                        flag = true;
                        break;
                    }
                }
                if (flag == false && depurado != null) {
                    if (depurado.denominacion.trim().length > 0) {

                        vm.norma.depuradoPors.push(depurado);
                    }
                }
                vm.modelDepuradoNorma = null;
            }
        }

        function removeDepurado(norma) {
            for (var i = 0; i < vm.norma.depuradoPors.length; i++) {
                if (vm.norma.depuradoPors[i].denominacion == norma.denominacion) {
                    vm.norma.depuradoPors.splice(i, 1);
                    break;
                }
            }
        }

        function addAbrogado() {
            console.log("addAbrogado");
            var abrogado = {};
            var flag = false;
            if (vm.modelAbrogadoNorma != null) {
                if (vm.modelAbrogadoNorma.denominacion != undefined) {
                    //abrogado.denominacion =  vm.modelAbrogadoNorma.denominacion;
                    //abrogado.id   =  vm.modelAbrogadoNorma.id;
                    abrogado = vm.modelAbrogadoNorma;
                } else {
                    abrogado.denominacion = vm.modelAbrogadoNorma.trim();
                    abrogado.denominacion = abrogado.denominacion.toUpperCase();
                    abrogado.id = null;
                    for (var i = 0; i < vm.responseNormas.length; i++) {
                        if (vm.responseNormas[i].denominacion.toUpperCase() == abrogado.denominacion) {
                            abrogado = vm.responseNormas[i];
                            break;
                        }
                    };
                }
                for (var i = 0; i < vm.norma.abrogadoPors.length; i++) {
                    if (vm.norma.abrogadoPors[i].denominacion == abrogado.denominacion) {
                        flag = true;
                        break;
                    }
                }
                if (flag == false && abrogado != null) {
                    if (abrogado.denominacion.trim().length > 0) {

                        vm.norma.abrogadoPors.push(abrogado);
                    }
                }
                vm.modelAbrogadoNorma = null;
            }
        }

        function removeAbrogado(norma) {
            for (var i = 0; i < vm.norma.abrogadoPors.length; i++) {
                if (vm.norma.abrogadoPors[i].denominacion == norma.denominacion) {
                    vm.norma.abrogadoPors.splice(i, 1);
                    break;
                }
            }
        }
    }

})();
